<div class="rotating-barcode" *ngIf="qrData">
  <div class="qr-frame {{ rotatingClass }}" [class.is-rotating]="rotating" [style.--sweep-duration]="sweepDuration">
    <div class="qr-surface">
      <qrcode [qrdata]="qrData" [width]="127" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
    </div>
  </div>

  <p class="font-size-12 text-black d-flex justify-content-center flex-wrap mb-0 mt-2">
    {{ 'wallet.barcode.scan' | translate }}
  </p>

  <span class="visually-hidden" aria-live="polite">{{ expiryMessage }}</span>
</div>
